<div class="loading-screen" *ngIf="loading" [class.visible]="loadingVisible">
  <div class="loading-animation">
    <div class="circle1"></div>
    <div class="circle2"></div>
  </div>
</div>
